import { render, staticRenderFns } from "./ButtonFunctionalities.vue?vue&type=template&id=248b413c&"
import script from "./ButtonFunctionalities.vue?vue&type=script&lang=js&"
export * from "./ButtonFunctionalities.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFunctionalities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports